import React from "react";
import { profileImgPlaceholder } from "../../../../assets/images";
import { Domain } from "../../../../config/API";
import { COLORS } from "../../../../config/theme";
import MainIconBar from "../MainIconBar";
import InfoBox from "../InfoBox";

import { ReactComponent as Vector1 } from "./Vector1.svg";
import { Col, Row } from "antd";
import SocialIconBar from "../SocialIconBar";

const Theme1 = ({ vCard, isPreview, downloadVcfFile, setShowExchangeCard }) => {
  const { primaryColor } = COLORS;
  const {
    fNamePrefix,
    fName,
    lName,
    lNameSuffix,
    email,
    company,
    jobTitle,
    mobile,
    address,
    bgImage,
    profileImage,
    pColor,
    sColor,
    socialLinks,
    leadEnable,
    owner,
    webLinks,
  } = vCard;
  return (
    <Col style={{ width: "100%", backgroundColor: sColor }}>
      <Col
        style={{
          position: "relative",
          minHeight: "25rem",
          background: `linear-gradient(to bottom, rgba(245, 246, 252, 0), rgba(0, 0,0, 0.8)),
          ${bgImage ? `url(${Domain}/data/${bgImage})` : pColor}`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          overflow: "hidden",
          backgroundPosition: "center",
        }}
        span={24}
      >
        <Row
          style={{
            position: "absolute",
            bottom: -56,
          }}
          span={24}
        >
          <Vector1 fill={sColor} style={{ width: "100%" }} />
        </Row>
        <Row
          span={24}
          style={{
            position: "absolute",
            display: "flex",
            width: "100%",
            bottom: 30,
          }}
        >
          <Col
            span={12}
            style={{
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "center",
            }}
          >
            <InfoBox
              fName={fName}
              jobTitle={jobTitle}
              company={company}
              black={false}
            />
          </Col>
          <Col span={12}>
            <Row
              style={{
                display: "flex",
              }}
            >
              <img
                className="profile-image"
                draggable={false}
                style={{
                  zIndex: 99,
                }}
                src={
                  profileImage
                    ? `${Domain}/data/${profileImage}`
                    : profileImgPlaceholder
                }
                alt=""
              />
            </Row>
            <Row
              style={{
                display: "flex",
                marginTop: 20,
              }}
              span={12}
            >
              <MainIconBar
                mobile={mobile}
                email={email}
                address={address}
                sColor={sColor}
                horizontal={true}
              />
            </Row>
          </Col>
        </Row>
      </Col>
      <SocialIconBar
        socialLinks={socialLinks}
        leadEnable={leadEnable}
        sColor={sColor}
        downloadVcfFile={downloadVcfFile}
        setShowExchangeCard={setShowExchangeCard}
        owner={owner}
        isBlack={false}
        webLinks={webLinks}
        isPreview={isPreview}
      />
    </Col>
  );
};

export default Theme1;
